import type { KAPLAYCtx } from '../types.ts'
import type { RoomOptions } from '../types.ts'
import { useLang } from '../providers/i18n/i18n.ts'
import { useGameUiTextFrame } from '../objects/game-ui-text-frame.ts'
import { getTiledSize, parsePolygon, getFileCacheStr } from '../utils.ts'

export function useWCMale(k: KAPLAYCtx) {
  const cacheStr = getFileCacheStr()
  k.loadSprite('wcMale', `sprites/rooms/wc-male.png?${cacheStr}`)
  k.loadSprite('wcMaleHover', `sprites/rooms/wc-male--hover.png?${cacheStr}`)
  const collidersJson = k.loadJSON('wcMaleColliders', `colliders/wc-male.parsed.json?${cacheStr}`)

  const { showTextFrame } = useGameUiTextFrame(k)
  const { getLangString } = useLang(k)

  function setWCMale(roomOpts?: RoomOptions) {
    roomOpts = roomOpts || {}

    const roomObj = k.add()

    k.onLoad(() => {
      const { data } = collidersJson

      roomObj.add([
        k.sprite('wcMale', {
          width: getTiledSize(data.width),
          height: getTiledSize(data.height),
        }),
        k.layer('background'),
        'wc_male_background',
        'background',
      ])

      roomObj.add([
        k.sprite('wcMaleHover', {
          width: getTiledSize(data.width),
          height: getTiledSize(data.height),
        }),
        k.layer('hover'),
        'wc_male_hover',
        'hover',
      ])

      data.objects.forEach((obj: any) => {
        const poly = parsePolygon(k, obj)
        roomObj.add([k.pos(), k.area({ shape: poly }), k.body({ isStatic: true }), 'colliders'])
      })

      roomObj.add([
        k.level(
          [
            '           ',
            '           ',
            '           ',
            '           ',
            '           ',
            '1    ?     ',
            '           ',
            '           ',
            '           ',
          ],
          {
            tileWidth: getTiledSize(),
            tileHeight: getTiledSize(),
            tiles: {
              '1': () => [
                k.rect(getTiledSize(0.5), getTiledSize(), { fill: false }),
                k.pos(getTiledSize(0.5), 0),
                k.area({ isSensor: true }),
                'wc_male_door_exit',
                'door_exit',
                'door',
              ],
              '?': () => [
                k.sprite('overlay', { anim: 'question' }),
                k.area({ isSensor: true }),
                k.layer('background'),
                'wc_male_info',
                'sfx_emit_action',
                'info',
              ],
            },
          },
        ),
        k.layer('objects'),
        'wc_male',
      ])

      // Set player position
      k.get('player')[0]?.setPos(k.vec2(getTiledSize(1.5), getTiledSize(5)))

      const doorExitCollision = k.onCollide('player', 'wc_male_door_exit', () => {
        k.flash(k.BLACK, 0.5)
        roomObj.destroy()
        doorExitCollision.cancel()
        infoCollision.cancel()
        infoCollisionEnd.cancel()
        if (roomOpts.onExit) roomOpts.onExit()
      })

      const infoCollision = k.onCollide('player', 'wc_male_info', () => {
        showTextFrame(getLangString('wc_male_info'))
      })

      const infoCollisionEnd = k.onCollideEnd('player', 'wc_male_info', () => {
        showTextFrame()
      })
    })

    return roomObj
  }

  return {
    setWCMale,
  }
}
